import React from 'react';
import { useTranslation } from 'react-i18next';

import { ChainCard } from 'components/Card';
import { ALL_CHAINS, CHAIN_DATA_MAPPING } from 'utils/constants';
import { ActionToButton } from 'components/Button';

const ChainCards = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4">
      {ALL_CHAINS.map((id) => (
        <div key={id} className="space-y-2 text-center">
          <ChainCard chainId={id} />
          <ActionToButton
            actionTo={CHAIN_DATA_MAPPING[id].exchangeUrl}
            actionTitle={t(`home.trade_${CHAIN_DATA_MAPPING[id].styleSlug}`)}
            isThemed={false}
          />
        </div>
      ))}
    </div>
  );
};

export default ChainCards;
